module.exports = __webpack_public_path__ + "img/water-level-0.42df8041.png";